import {useEffect} from 'react'
import {Lang} from '../../../../app/modules/auth/apis'
import {
  searchAndPagingLocationDistrict,
  searchAndPagingLocationNew,
  searchAndPagingLocationProvince,
  searchAndPagingLocationWard,
} from '../../../../app/modules/insurance/healthInsurance/apis'
import {AllMessages, useLocalStorage} from '../../../../app/utils'
import {toAbsoluteUrl} from '../../../helpers'

export function FallbackView() {
  const [lang] = useLocalStorage<Lang>('i18nConfig', {selectedLang: 'vi'})
  const [provinces] = useLocalStorage<any>('provinces', [])

  const callApiGetAddress = async () => {
    // await Promise.all([searchAndPagingLocationNew])
    //   .then((res: any) => {
    //     console.log(res)

    //     // localStorage.setItem('wards', JSON.stringify(resWard))
    //   })
    //   .catch((error) => {
    //     return
    //   })

    searchAndPagingLocationNew()
      .then((res: any) => {
        let resProvince = res.result.items
          .filter((x: any) => x.parentCode == null)
          .map((o: any) => ({
            value: o.code,
            label: o.name,
          }))

        let resDistrict = res.result.items
          .filter((x: any) => x.parentCode != null)
          .map((o: any) => ({
            value: o.code,
            label: o.name,
            parent: o.parentCode,
          }))

        resProvince.unshift({
          value: '0',
          label: 'Chọn Tỉnh/Thành phố',
        })
        localStorage.setItem('provinces', JSON.stringify(resProvince))
        localStorage.setItem('districts', JSON.stringify(resDistrict))
      })
      .catch((error) => {
        return
      })

    // searchAndPagingLocationWard()
    //   .then((res: any) => {
    //     let resWard = res.result.items.map((o: any) => ({
    //       value: o.code,
    //       label: o.name,
    //       parent: o.parentCode,
    //     }))
    //     localStorage.setItem('wards', JSON.stringify(resWard))
    //   })
    //   .catch((error) => {
    //     return
    //   })
  }

  useEffect(() => {
    if (provinces && provinces.length === 0) {
      callApiGetAddress()
    }
  }, [])

  return (
    <div className='splash-screen'>
      <img src={toAbsoluteUrl('/media/logos/logo-tmiv.png')} alt='Start logo' className='h-30px' />
      <span>{AllMessages[lang.selectedLang].DANG_TAI} ...</span>
    </div>
  )
}